import { MenuItem, TextField } from "@mui/material";

import {
    Shared_FormTemplate_QuestionTypeDropdownFragment,
    Shared_FormTemplate_QuestionTypeSelectFragment,
} from "../fragments/fragmentsTypes.generated";
import { NarrowedFormField } from "../types";

type Props = {
    disabled?: boolean;
    field: NarrowedFormField<
        Shared_FormTemplate_QuestionTypeSelectFragment | Shared_FormTemplate_QuestionTypeDropdownFragment
    >;
    value?: string | null;
    onChange?: (value: string) => void;
};

export default function QuestionDropdown({ disabled, field, value, onChange }: Props) {
    return (
        <TextField
            select
            helperText={field.description}
            placeholder={field.placeholder || undefined}
            label={field.name}
            value={value}
            onChange={e => onChange?.(e.target.value)}
            disabled={disabled}
            fullWidth
            required={field.isRequired ?? false}
        >
            {field.type.options.map(({ id, key, name }) => (
                <MenuItem
                    key={id}
                    value={key}
                    disabled={disabled || !onChange}
                    sx={{
                        "&.Mui-disabled": {
                            opacity: 1,
                        },
                    }}
                >
                    {name}
                </MenuItem>
            ))}
        </TextField>
    );
}
